module.exports = __webpack_public_path__ + "static/sw-screen-cf89ad58f0fab5adcb05fb60736179e1.jpg";